/*
 * Version of StatementLines specific to reseller
 */
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Link, TableContainer, Table,  TableBody, TableCell, TableHead, TableRow, Tooltip } from '@mui/material';
import { format } from 'date-fns';

const styleSheet = theme => ({
    paper: {
      width: '100%',
      marginTop: theme.spacing(1),
      overflow: 'auto',
      // [theme.breakpoints.up('xs')]: {
      //  padding: theme.spacing(1),
      // },
      // [theme.breakpoints.up('sm')]: {
      //   padding: theme.spacing(2),
      // },
      // [theme.breakpoints.up('md')]: {
      //   padding: theme.spacing(3),
      // },
    },
    tblHead: {
      backgroundColor: '#f1f1f1',
    },
    tblHeadRow: {
      height: 24,
    },
    tblCellPositive: {
      textAlign: 'right',
      color: '#006400'
    },
    tblCellNegative: {
      textAlign: 'right',
      color: 'red'
    },
    appnameitem: {
      marginLeft: 8,
    },
    linkitalic: {
      fontStyle: 'italic',
    },
});

class VendorStatementLines extends React.Component {
  
  renderResellerTableCell= (accountId, accountName, classes) => {

    if (!accountName) {
      return '';
    }


    let aUrl = "resellervendor?accountId=" + accountId + "&fp=Statements";

    if (classes != null) {
      return (
        <Link component="button" 
              variant="body2"
              className={classes.linkitalic}
              onClick={this.goTo.bind(this, aUrl)}>
          {accountName}
        </Link>
      );
    } else {
      return (
        <Link component="button" 
              variant="body2"
              onClick={this.goTo.bind(this, aUrl)}>
          {accountName}
        </Link>
      );
    }
    

  }

  renderProgramTableCell= (pId, programName, classes) => {

    if (!programName) {
      return '';
    }


    let aUrl = "resellerprogramedit?resellerPId=" + pId + "&fp=Statements";

    if (classes != null) {
      return (
        <Link component="button" 
              variant="body2"
              className={classes.linkitalic}
              onClick={this.goTo.bind(this, aUrl)}>
          {programName}
        </Link>
      );
    } else {
      return (
        <Link component="button" 
              variant="body2"
              onClick={this.goTo.bind(this, aUrl)}>
          {programName}
        </Link>
      );
    }
    

  }



  goToCustomer(route, tabValue) {
    localStorage.setItem('customerTabVal', tabValue);

    this.props.history.push(`/${route}`);
  }

  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  render() {
    const classes = this.props.classes;
    const thenodes = this.props.cl.nodes;

    return (
      <div className={classes.paper}>
        <TableContainer>
          <Table>
            <TableHead className={classes.tblHead}>
              <TableRow className={classes.tblHeadRow}>
                <TableCell>Date</TableCell> 
                <TableCell>Period</TableCell> 
                <TableCell>Reseller</TableCell>
                <TableCell>Reseller program</TableCell>
                <TableCell align="right"><Tooltip title='Rebate owed to reseller'><div>Payout</div></Tooltip></TableCell>
                <TableCell align="right"><Tooltip title='AppBind fees'><div>AppBind</div></Tooltip></TableCell>
                {/* <TableCell align="right"><Tooltip title='Balance'><div>Bill Total</div></Tooltip></TableCell> */}
                <TableCell align="right"><Tooltip title='Payment into AppBind for rebate and fees'><div>Payment</div></Tooltip></TableCell>
                <TableCell align="right"><Tooltip title='Reversals and other amounts received from reseller'><div>Received</div></Tooltip></TableCell>
                <TableCell align="right"><Tooltip title='Balance of your funds in AppBind'><div>Balance</div></Tooltip></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              { thenodes.map(n => {
                let thePurpose = n.rowPurpose;
                let transDate;
                let payoutAmount = '';
                let payoutClass = classes.tblCellNegative;
                let receivedClass = classes.tblCellPositive;
                let feeAmount = '';
                let paidAmount = '';
                let paidClass = classes.tblCellPositive;
                let receivedAmount = '';
                let pStart = format(new Date(n.vendorPayoutStart), 'MMM yyyy');
                let paymentOutMessage = '';

                if (thePurpose === 0) {
                  transDate = format(new Date(n.billTransactionTime), 'yyyy-MM-dd');
                  payoutAmount = '(' + Number(n.payoutAmount).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
                  feeAmount = '(' + Number(n.feeAmount).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
                  if (n.vendorConfAmount != null) {
                    let theAmt = Number(n.vendorConfAmount) * -1;
                    paidAmount = Number(theAmt).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                  }
                } else if (thePurpose === 1) {
                  transDate = format(new Date(n.revTransactionTime), 'yyyy-MM-dd');
                  receivedAmount = Number(n.vendorRevAmount).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                } else {
                  transDate = format(new Date(n.billTransactionTime), 'yyyy-MM-dd');
                  pStart = '';
                  paymentOutMessage = 'Balance payout';
                  if (n.vendorConfAmount != null) {
                    let theAmt = Number(n.vendorConfAmount);
                    if (theAmt < 0) {
                      theAmt = theAmt * -1;
                      paidClass = classes.tblCellNegative;
                      paidAmount = '(' + Number(theAmt).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
                    } else {
                      paidAmount = Number(theAmt).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                    }
                  }
                }
                
                let balance = null;
                let balanceAmtClass = classes.tblCellNegative;
   
                // let vendorBillTotal = '(' + Number(n.vendorBillTotal).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
                // Balance is on all
                if (n.balance < 0) {
                  let tbal = n.balance * -1;
                  balance = '(' + Number(tbal).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
                } else {
                  balanceAmtClass = classes.tblCellPositive;
                  balance = Number(n.balance).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                }

                return (
                  <TableRow key={n.transactionId}>
                    <TableCell style={{whiteSpace: 'nowrap'}}>{transDate}</TableCell>
                    {(thePurpose === 0 || thePurpose === 1) &&
                    <React.Fragment>
                      <TableCell style={{whiteSpace: 'nowrap'}}>{pStart}</TableCell>
                      <TableCell style={{whiteSpace: 'nowrap'}}>{this.renderResellerTableCell(n.resellerAccountId, n.resellerAccountName, null)}</TableCell>
                      <TableCell style={{whiteSpace: 'nowrap'}}>{this.renderProgramTableCell(n.resellerPId, n.resellerProgramName, null)}</TableCell>
                    </React.Fragment>}
                    {thePurpose === 2 &&
                    <TableCell colspan={3} style={{whiteSpace: 'nowrap'}}>{paymentOutMessage}</TableCell>}

                    <TableCell className={payoutClass}>{payoutAmount}</TableCell>
                    <TableCell className={classes.tblCellNegative}>{feeAmount}</TableCell>
                    {/* <TableCell className={classes.tblCellNegative}>{vendorBillTotal}</TableCell> */}
                    <TableCell className={paidClass}>{paidAmount}</TableCell>
                    <TableCell className={receivedClass}>{receivedAmount}</TableCell>
                    <TableCell className={balanceAmtClass}>{balance}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );

  } // end render()
}

VendorStatementLines.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(VendorStatementLines);
